import { NavLink } from "hooks/useCustomNavigation";
import { DownloadMobileApp, VisitHelpCenter } from "components/UI/molecules";
import {
  FAQSection,
  ReferAFriendAdvertising,
  ReferralProgramTestimonial,
  ReferralBrands
} from "components/UI/organisms";
import { INTERNAL_PATHS } from "routes/paths";
import { REFER_A_FRIEND_FAQ } from "./utils/content";
import "./index.scss";

export const ReferAFriend = () => {
  return (
    <>
      <section className="header-refer">
        <h1 className="page-title">Earn GCX Cash by Referring Friends Today</h1>
        <p className="page-description">
          Have a friend who loves to shop? Earn GCX Cash for every person you
          refer and help them save money, too. We’ll give you and your friend $5
          just for spreading the good word!
        </p>
        <NavLink
          className="invite-friends-anchor"
          to={INTERNAL_PATHS.MY_REFERRALS}
        >
          INVITE FRIENDS NOW
        </NavLink>
      </section>
      <ReferAFriendAdvertising />
      <ReferralProgramTestimonial />
      <FAQSection faqList={REFER_A_FRIEND_FAQ} />
      <ReferralBrands />
      <DownloadMobileApp />
      <VisitHelpCenter />
    </>
  );
};
